export default __webpack_public_path__ + "static/media/content_head.86f5e68f.svg";